module.exports = __webpack_public_path__ + "static/media/7.3b770ea1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/7.svg
// module id = 167
// module chunks = 0